const axios = require('axios');

export default {
  data() {
    return {
      destinationObject: null,
      glink: null,
      masterplanConfig: null,
      method: 'driving',
      origin: null,
      poi: null,
      predictions: null,
      route: null,
      sub: null
    }
  },
  methods: {
    listenToMutation: function () {
      this.masterplanConfig = this.$store.state.amenityStore.masterplanConfig;
      this.poi = this.$store.state.amenityStore.poi;
      this.sub = this.$store.subscribe((mutation, state) => {
        if (mutation.type === "setMasterplanConfig") {
          this.masterplanConfig = state.amenityStore.masterplanConfig;
        }

        if (mutation.type === "setPoi") {
          this.poi = state.amenityStore.poi;
        }

        if (mutation.type === "setRouteInfo") {
          this.route = state.amenityStore.routeInfo;
        }
      })
    },

    getOrigin: function () {
      const master = this.masterplanConfig.svgFileConfigs.find(item => item.svgFileType.fileType === 'MASTER');
      if (master && master.poe) {
        this.origin = {lng: master.poe.lng, lat: master.poe.lat}
      }
    },

    fetchPlacesPrediction: function (val) {
      const place = encodeURI(val.trim());
      const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${place}.json?types=address&proximity=${this.origin.lng},${this.origin.lat}&access_token=${mapboxgl.accessToken}`;
      axios.get(url).then(res => {
        this.predictions = res.data.features;
      }).catch(err => {
        return err;
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Travel.js